import { bool } from 'prop-types';
import React, { useRef } from 'react';

import CurrencyFormat from '../../generic/CurrencyFormat';
import EntityLabel from '../../generic/EntityLabel';
import HoverDetails from '../../generic/HoverDetails';
import IconLink from '../../generic/IconLink';
import { basicQuoteShape } from '../../prop-types';

function QuoteLink({ model, showIcon, verbose, ...rest }) {
  const {
    id,
    name,
    number,
    campaignObjective,
    netClientBudget,
    flexibilityTerms,
    allowedFlexibilities,
  } = model;
  const linkRef = useRef(null);
  const link = (
    <>
      <span ref={linkRef}>
        <IconLink showIcon={showIcon} to={`/quotes/${id}/edit`} {...rest}>
          {name || number}
        </IconLink>
      </span>
      <HoverDetails
        size="large"
        linkRef={linkRef}
        title={name || number}
        fields={{
          Objective: campaignObjective,
          'Net Client Budget': (
            <CurrencyFormat
              name="netClientBudget"
              value={netClientBudget || 0}
              text
            />
          ),
          'Flexibility Terms': flexibilityTerms,
          'Allowed Flexibilities': allowedFlexibilities
            ? allowedFlexibilities.join(', ')
            : '-',
        }}
      />
    </>
  );

  return verbose ? (
    <EntityLabel id={model.id} resourceType="quote">
      {link}
    </EntityLabel>
  ) : (
    link
  );
}

QuoteLink.propTypes = {
  model: basicQuoteShape.isRequired,
  showIcon: bool,
  verbose: bool,
};

QuoteLink.defaultProps = {
  showIcon: false,
  verbose: false,
};

export default QuoteLink;
